<template>
  <van-popup v-model="show" position="bottom" :round="true" closeable  close-icon-position="top-right"   :style="{ 'padding-top': '25px' }">   
    <div :class="preClass">
        <div class="title-wrap">
                <p>{{title}}</p>
        </div>
        <base-table :data="subjectData" :headers="headers"></base-table>
    </div>
  </van-popup>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      preClass: "subject-detail",
      show: false,
      subjectData: [],
      headers: ["科目名称", "科目余额"],


    };
  },
  props:{
      label:[String],
      date:[String],
      title:String,
      data:Array
  },
  watch: {
    show: {
      handler: function() {
        if (this.show) {
          if(this.data){
              this.subjectData = this.data
          }else{
              this.init();
          }
        }
      },
      immediate: true
    },
  },
  computed: {
    ...mapGetters(["currClient", "currDate"]),
  },
  methods: {
    init() {
      this.subjectData = [];
      let balanceData =  JSON.parse(window.localStorage.getItem('balanceData')) 
      if(balanceData){
        this.setTableData(balanceData)
      }else{
        this.getBalanceData()
      }
  
    },
    getBalanceData(){
      this.$store.commit('app/SET_LOADING_STATUS', true)
          let params = {
            begin_ym: this.date||this.currDate,
            end_ym: this.date||this.currDate,
            page: 1,
            rows: 99999999
          };
          this.$axios.post("/account-book/account-balance", params).then(res => {
        if (res.success && res.rows) {
          
          window.localStorage.setItem('balanceData',JSON.stringify( res.rows))
          this.setTableData(res.rows)
        }
      }).finally(_=>{
         this.$store.commit('app/SET_LOADING_STATUS', false)

      });
    },
    setTableData(balanceData){
      let resultArr = []
        balanceData.forEach(item => {
            if (item.name === this.label) {
               item.children.map(incomItem => {
                let item =   {
                  ...incomItem,
                  title: incomItem.name,
                  value: incomItem.end_balance,
                  align: "around",
                  color: "blue",
                  filter: "toThousandFilter"
                };
                if(item.value>0){
                   resultArr.push(item)
                }
              });
            }
          });
          this.subjectData = resultArr;

    }
  }
};
</script>

<style lang="less">
.subject-detail {
  min-height: 300px;
  padding: 20px;

}
</style>



// WEBPACK FOOTER //
// src/components/commons/subject-detail.vue